module.exports = __webpack_public_path__ + "static/button-controls-002a0ee4cd7bc851a3b28191d5bd7c47.png";